import React, { useState } from 'react';
import { supabase } from '../supabaseClient';
import { useNavigate, Link } from 'react-router-dom';

export default function Register() {
  const [fullName, setFullName] = useState('');
  const [institution, setInstitution] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [role, setRole] = useState('viewer');
  const [healthcareConfirmed, setHealthcareConfirmed] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  async function handleRegister(e) {
    e.preventDefault();

    if (!healthcareConfirmed) {
      setError('Bu sisteme yalnızca sağlık çalışanları erişebilir. Devam etmek için sağlık çalışanı olduğunuzu onaylamanız gerekir.');
      return;
    }

    setLoading(true);
    setError('');

    const { error: signUpError } = await supabase.auth.signUp({
      email,
      password,
      options: {
        data: {
          full_name: fullName,
          institution,
          requested_role: role === 'admin' ? 'admin' : null,
          healthcare_confirmed: true,
        },
        emailRedirectTo: 'https://trial-track-xi.vercel.app',
      }
    });

    if (signUpError) {
      setError(signUpError.message);
      setLoading(false);
      return;
    }

    setSuccess(true);
    setLoading(false);
  }

  if (success) return (
    <div style={styles.container}>
      <div style={styles.card}>
        <div style={styles.logoWrap}><span style={styles.logoIcon}>✅</span></div>
        <h2 style={{ color: '#1e3a5f', textAlign: 'center', marginBottom: '1rem' }}>Kayıt Tamamlandı!</h2>
        <p style={{ textAlign: 'center', color: '#475569', lineHeight: 1.7, marginBottom: '1.5rem' }}>
          Hesabınız oluşturuldu. Hemen giriş yapabilirsiniz.
          {role === 'admin' && <><br /><br />Merkez Sorumlusu talebiniz yönetici onayına gönderildi. Onaylanana kadar hesabınız <strong>Kullanıcı</strong> yetkisiyle çalışır.</>}
        </p>
        <button style={styles.button} onClick={() => navigate('/login')}>
          Giriş Yap
        </button>
      </div>
    </div>
  );

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <div style={styles.logoWrap}><span style={styles.logoIcon}>🔬</span></div>
        <h1 style={styles.title}>Klinik Araştırma Takip Portalı</h1>
        <p style={styles.subtitle}>Yeni Hesap Oluştur</p>
        <form onSubmit={handleRegister}>
          <input style={styles.input} type="text" placeholder="Ad Soyad" value={fullName} onChange={e => setFullName(e.target.value)} required />
          <input style={styles.input} type="text" placeholder="Kurum / Hastane" value={institution} onChange={e => setInstitution(e.target.value)} required />
          <input style={styles.input} type="email" placeholder="E-posta" value={email} onChange={e => setEmail(e.target.value)} required />
          <input style={styles.input} type="password" placeholder="Şifre (min. 6 karakter)" value={password} onChange={e => setPassword(e.target.value)} required minLength={6} />

          <div style={styles.roleBox}>
            <label style={styles.roleLabel}>Hesap Türü Seçin:</label>
            <div style={styles.roleOptions}>
              <label style={{ ...styles.roleOption, ...(role === 'viewer' ? styles.roleOptionActive : {}) }}>
                <input type="radio" name="role" value="viewer" checked={role === 'viewer'} onChange={() => setRole('viewer')} style={{ display: 'none' }} />
                <div style={styles.roleIcon}>👁️</div>
                <div style={styles.roleName}>Kullanıcı</div>
                <div style={styles.roleDesc}>Çalışmaları görüntüler ve arar</div>
              </label>
              <label style={{ ...styles.roleOption, ...(role === 'admin' ? styles.roleOptionActive : {}) }}>
                <input type="radio" name="role" value="admin" checked={role === 'admin'} onChange={() => setRole('admin')} style={{ display: 'none' }} />
                <div style={styles.roleIcon}>🏥</div>
                <div style={styles.roleName}>Merkez Sorumlusu</div>
                <div style={styles.roleDesc}>Kendi merkezinin çalışmalarını yönetir · yönetici onayı gerekir</div>
              </label>
            </div>
          </div>

          <div style={styles.disclosure}>
            <div style={styles.disclosureHeader}>
              <span style={styles.disclosureIcon}>⚕️</span>
              <strong style={styles.disclosureTitle}>Sağlık Çalışanı Onayı (Zorunlu)</strong>
            </div>
            <p style={styles.disclosureText}>
              Klinik Araştırma Takip Portalı yalnızca <strong>aktif olarak görev yapan sağlık çalışanlarına</strong>
              {' '}(hekim, hemşire, eczacı, klinik araştırma koordinatörü, veri yöneticisi vb.) yönelik mesleki bir
              platformdur. Sistem; klinik çalışmalara ilişkin hassas tıbbi ve bilimsel bilgiler içerir ve hasta
              odaklı sağlık tavsiyesi sunmaz.
            </p>
            <p style={styles.disclosureText}>
              Sağlık çalışanı olmayan kişilerin kaydı, sisteme erişimi ve içerikleri kullanımı kesinlikle yasaktır.
              Yanlış beyanda bulunulması halinde hesap derhal kapatılır ve ilgili mevzuat çerçevesinde yasal işlem
              başlatılabilir. Paylaştığınız bilgilerin KVKK ve mesleki gizlilik kuralları kapsamında işleneceğini
              kabul etmiş sayılırsınız.
            </p>
            <label style={styles.confirmCheck}>
              <input
                type="checkbox"
                checked={healthcareConfirmed}
                onChange={e => setHealthcareConfirmed(e.target.checked)}
                style={styles.checkbox}
                required
              />
              <span style={styles.checkLabel}>
                Sağlık çalışanı olduğumu, yukarıdaki bilgilendirme metnini okuyup anladığımı ve verdiğim bilgilerin
                doğru olduğunu beyan ve kabul ederim.
              </span>
            </label>
          </div>

          {error && <p style={styles.error}>{error}</p>}
          <button
            style={{ ...styles.button, ...((loading || !healthcareConfirmed) ? styles.buttonDisabled : {}) }}
            type="submit"
            disabled={loading || !healthcareConfirmed}
          >
            {loading ? 'Kaydediliyor...' : 'Kayıt Ol'}
          </button>
        </form>
        <p style={styles.link}>Zaten hesabın var mı? <Link to="/login">Giriş Yap</Link></p>
      </div>
    </div>
  );
}

const styles = {
  container: { minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#f0f4f8', padding: '2rem' },
  card: { background: 'white', padding: '2.5rem', borderRadius: '12px', boxShadow: '0 4px 20px rgba(0,0,0,0.1)', width: '100%', maxWidth: '460px' },
  logoWrap: { textAlign: 'center', marginBottom: '0.75rem' },
  logoIcon: { fontSize: '2.5rem' },
  title: { textAlign: 'center', color: '#1e3a5f', marginBottom: '0.25rem', fontSize: '1.2rem', fontWeight: '700', lineHeight: 1.3 },
  subtitle: { textAlign: 'center', color: '#64748b', marginBottom: '1.5rem', fontSize: '0.9rem' },
  input: { width: '100%', padding: '0.75rem', marginBottom: '1rem', border: '1px solid #cbd5e1', borderRadius: '8px', fontSize: '1rem', boxSizing: 'border-box' },
  button: { width: '100%', padding: '0.75rem', background: '#1e3a5f', color: 'white', border: 'none', borderRadius: '8px', fontSize: '1rem', cursor: 'pointer', marginTop: '0.5rem', transition: 'background 0.2s, opacity 0.2s' },
  buttonDisabled: { background: '#94a3b8', color: '#f1f5f9', cursor: 'not-allowed', opacity: 0.7 },
  error: { color: '#ef4444', marginBottom: '1rem', fontSize: '0.875rem' },
  link: { textAlign: 'center', marginTop: '1rem', fontSize: '0.875rem', color: '#64748b' },
  roleBox: { marginBottom: '1rem' },
  roleLabel: { display: 'block', fontSize: '0.85rem', color: '#475569', fontWeight: '600', marginBottom: '0.75rem' },
  roleOptions: { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '0.75rem' },
  roleOption: { border: '2px solid #e2e8f0', borderRadius: '10px', padding: '1rem', cursor: 'pointer', textAlign: 'center', transition: 'all 0.2s' },
  roleOptionActive: { border: '2px solid #1e3a5f', background: '#eff6ff' },
  roleIcon: { fontSize: '1.5rem', marginBottom: '0.4rem' },
  roleName: { fontWeight: '600', color: '#1e293b', fontSize: '0.875rem', marginBottom: '0.25rem' },
  roleDesc: { fontSize: '0.75rem', color: '#64748b', lineHeight: 1.3 },
  disclosure: { background: '#fff7ed', border: '1px solid #fdba74', borderRadius: '10px', padding: '1rem', marginBottom: '1rem' },
  disclosureHeader: { display: 'flex', alignItems: 'center', gap: '0.5rem', marginBottom: '0.5rem' },
  disclosureIcon: { fontSize: '1.1rem' },
  disclosureTitle: { color: '#9a3412', fontSize: '0.9rem' },
  disclosureText: { fontSize: '0.78rem', color: '#7c2d12', lineHeight: 1.55, marginBottom: '0.6rem' },
  confirmCheck: { display: 'flex', alignItems: 'flex-start', gap: '0.5rem', marginTop: '0.5rem', cursor: 'pointer' },
  checkbox: { marginTop: '0.2rem', width: '16px', height: '16px', cursor: 'pointer', accentColor: '#1e3a5f' },
  checkLabel: { fontSize: '0.78rem', color: '#1e293b', lineHeight: 1.5, fontWeight: '500' },
};
